import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { branchFormSchema } from '../types'
import type { BranchFormData } from '../types'

interface BranchFormProps {
  defaultValues?: Partial<BranchFormData>
  onSubmit: (data: BranchFormData) => void
  isSubmitting: boolean
  submitLabel?: string
  error?: string | null
}

export function BranchForm({
  defaultValues,
  onSubmit,
  isSubmitting,
  submitLabel = 'Guardar',
  error,
}: BranchFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<BranchFormData>({
    resolver: zodResolver(branchFormSchema),
    defaultValues: {
      commune: '',
      address: '',
      ...defaultValues,
    },
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6 max-w-2xl">
      {error && (
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
          {error}
        </div>
      )}

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Comuna *</label>
        <input {...register('commune')} className="input" />
        {errors.commune && (
          <p className="text-red-500 text-sm mt-1">{errors.commune.message}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Dirección *</label>
        <input {...register('address')} className="input" />
        {errors.address && (
          <p className="text-red-500 text-sm mt-1">{errors.address.message}</p>
        )}
      </div>

      <div className="flex gap-3">
        <button type="submit" disabled={isSubmitting} className="btn btn-primary">
          {isSubmitting ? 'Guardando...' : submitLabel}
        </button>
      </div>
    </form>
  )
}
